import { configureStore } from '@reduxjs/toolkit';
import { accountReducer } from 'account/common/context/AccountSlice';
import { sahinYazilimReducer } from 'context/SahinYazilimSlice';
import { commonReducer } from './CommonSlice';
import { orderReducer } from '../../context/OrderSlice';
import { branchReducer } from './BranchSlice';
// import api from './api';

export const store = configureStore({
  reducer: {
    // [api.reducerPath]: api.reducer,
    common: commonReducer,
    account: accountReducer,
    sahinyazilim: sahinYazilimReducer,
    order: orderReducer,
    branch: branchReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
